var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageNotFoundActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26,
    r: 26,
    fill: "#AFCA0A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.998 19.0024C24.1226 19.0026 25.043 19.9237 25.043 21.0483C25.0428 22.1761 24.123 23.0931 22.998 23.0933C21.8692 23.0933 20.9523 22.1799 20.9521 21.0483C20.9521 19.9232 21.8701 19.0024 22.998 19.0024ZM23.002 19.5952C22.2024 19.5952 21.5488 20.2488 21.5488 21.0483C21.549 21.8478 22.2025 22.5005 23.002 22.5005C23.8012 22.5002 24.4539 21.8476 24.4541 21.0483C24.4541 20.2489 23.8013 19.5955 23.002 19.5952Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7087 15.9106H33.0271L32.4343 16.5034H17.0037V30.7788L17.9197 29.4067L19.0652 27.6899C19.3913 27.211 19.9311 26.9253 20.4978 26.9253C20.9077 26.9254 21.299 27.0726 21.6042 27.3335L21.1833 27.7544C20.9911 27.6057 20.7539 27.5181 20.4978 27.5181C20.1138 27.5181 19.7695 27.7117 19.5603 28.019L19.5583 28.022L17.0886 31.7124L17.0037 31.8394V31.938L16.4109 32.5308V16.2085L16.4167 16.1489C16.4451 16.0142 16.5671 15.9109 16.7087 15.9106Z",
    fill: "white",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9919 32.3696L35.8787 32.231L30.45 25.6108L30.8689 25.1919L35.1101 30.3501L35.9958 31.4282V20.0649L36.5886 19.4722V35.7905C36.5886 35.954 36.4553 36.0906 36.2869 36.0923H19.9685L20.5613 35.4995H35.9919V32.3696Z",
    fill: "white",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4634 13.3169C38.6635 13.1168 38.983 13.1168 39.1831 13.3169C39.3831 13.517 39.3831 13.8365 39.1831 14.0366L14.5366 38.6831C14.4387 38.781 14.3114 38.8306 14.1782 38.8306C14.0475 38.8305 13.9199 38.7824 13.8169 38.6831C13.6168 38.483 13.6168 38.1635 13.8169 37.9634L38.4634 13.3169Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageNotFoundActive);
export default __webpack_public_path__ + "static/media/image-not-found-active.140cc033e9d2b6c4d68cdb8aa4b99233.svg";
export { ForwardRef as ReactComponent };